import { render, staticRenderFns } from "./AbstractCard.vue?vue&type=template&id=3a1b90b4&"
import script from "./AbstractCard.vue?vue&type=script&lang=js&"
export * from "./AbstractCard.vue?vue&type=script&lang=js&"
import style0 from "./AbstractCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports